export const CID_ELIGIBLE_TENANT = 'Anthem';